<template>
  <div class="statistiche-validatori">
    <div class="header-section">
      <h2 class="page-title">Statistiche Validatori</h2>
      <p class="subtitle">Monitoraggio attività di validazione contratti</p>
    </div>
    <Loader v-if="loading" />

    <div v-else class="content-section">
      <div class="col-12 md:col-4" style="max-height: 90px;">
        <div class="col-12">Filtra per data caricamento</div>
        <div class="mb-0 flex justify-content-center">
          <Calendar ref="calendarRef" v-model="selectedDate" @today-click="onTodayClick()"
            :maxDate="maxDate" selectionMode="range" :manualInput="false"
            @update:modelValue="onChangeDate()" dateFormat="dd/mm/yy" class="w-full"
            style="height: 45px" showButtonBar />
        </div>
      </div>

      <div class="stats-grid">
        <div class="stat-card stat-card-info">
          <div class="stat-number">{{ totalValidazioni }}</div>
          <div class="stat-label">Totale Validazioni</div>
        </div>
        <div class="stat-card stat-card-success">
          <div class="stat-number">{{ uniqueValidators }}</div>
          <div class="stat-label">Validatori Attivi</div>
        </div>
        <div class="stat-card stat-card-warning">
          <div class="stat-number">{{ mediaValidazioniPerGiorno }}</div>
          <div class="stat-label">Media Validazioni/Giorno</div>
        </div>
      </div>
      
      <div class="stats-grid">
        <div v-for="(index, stat) of stats" :key="index" class="stat-card stat-card-info">
          <div class="stat-number">{{ stats[stat] }}</div>
          <div class="stat-label">{{stat}} {{['in attesa'].includes(stat) ? 'validazione' : 'da validare'}}</div>
        </div>
      </div>

      <div class="tables-section">
        <div class="table-container">
          <div class="table-header">
            <h3 class="table-title">
              Dettaglio Validazioni
            </h3>
          </div>

          <div class="table-wrapper">
            <DataTable :value="filteredItems" :paginator="true" :rows="20" :rowsPerPageOptions="[20, 50, 200]"
              responsiveLayout="scroll"
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Mostra {first} - {last} di {totalRecords} record" class="p-datatable-sm"
              :sortField="'giorno'" :sortOrder="-1">
              <Column field="quanti" header="N. Contratti Validati" :sortable="true">
                <template #body="slotProps">
                  <span class="validation-count-badge" :class="getValidationCountClass(slotProps.data.quanti)">
                    {{ slotProps.data.quanti }}
                  </span>
                </template>
              </Column>

              <Column field="chi" header="Utente Validatore" :sortable="true">
                <template #body="slotProps">
                  <span class="user-badge">
                    <i class="pi pi-user"></i>
                    {{ slotProps.data.chi }}
                  </span>
                </template>
              </Column>

              <Column field="giorno" header="Giorno Validazione" :sortable="true">
                <template #body="slotProps">
                  <span class="date-badge">
                    <i class="pi pi-calendar"></i>
                    {{ moment(slotProps.data.giorno).format('DD/MM/YYYY') }}
                  </span>
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>

    <Toast />
  </div>
</template>

<script>
import { ref, onMounted, getCurrentInstance, computed } from 'vue';
import { useToast } from 'primevue/usetoast';
import moment from 'moment';

import Loader from "@/components/Loader.vue";
import Service from '@/services/ask-pratiche/pratiche-wizard';

export default {
  name: 'StatisticheValidatori',
  components: {
    Loader
  },
  setup() {
    const toast = useToast();
    const loading = ref(false);
    const items = ref([]);
    const selectedDate = ref([]);
    const maxDate = ref(new Date());
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    const service = new Service(self.$eventBus);
    const stats = ref({
      'contratti':0,
      'pod':0,
      'pdr':0,
      'totale':0
    })

    const initializeDateRange = () => {
      const today = new Date();
      const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      selectedDate.value = [today, today];
    };

    const filteredItems = computed(() => {
      if (!selectedDate.value || selectedDate.value.length !== 2) {
        return items.value;
      }

      const [startDate, endDate] = selectedDate.value;
      const start = moment(startDate).startOf('day');
      const end = moment(endDate).endOf('day');

      return items.value.filter(item => {
        const itemDate = moment(item.giorno);
        return itemDate.isBetween(start, end, null, '[]');
      });
    });

    const totalValidazioni = computed(() => {
      return filteredItems.value.reduce((sum, item) => sum + (item.quanti || 0), 0);
    });

    const uniqueValidators = computed(() => {
      const unique = new Set(filteredItems.value.map(item => item.chi));
      return unique.size;
    });

    const mediaValidazioniPerGiorno = computed(() => {
      if (filteredItems.value.length === 0) return 0;

      let result = 0
      if (selectedDate.value) {
        const [startDate, endDate] = selectedDate.value;
        const start = moment(startDate);
        const end = moment(endDate);
        const daysDiff = end.diff(start, 'days') + 1;
        result = Math.round(totalValidazioni.value / daysDiff)      
      }else if(items.value.length > 0){
        const start = moment(items.value[0].giorno);
        const end = moment(items.value[items.value.length-1].giorno);
        const daysDiff = end.diff(start, 'days') + 1;
        result = Math.round(totalValidazioni.value / daysDiff)
      }

      return result;
    });

    const getData = async () => {
      let fd = new FormData();
      let range = []
      if (selectedDate.value) {
        selectedDate.value.forEach((data) => {
          let giorno = data.getDate() 
          giorno = giorno.toString().padStart(2,'0')
          let mese = data.getMonth()+1
          mese = mese.toString().padStart(2,'0')
          let anno = data.getFullYear() 
          data = `${anno}-${mese}-${giorno}`
          range.push(data)
        })        
      }
      fd.append('range', range);

      loading.value = true;
      try {
        const response = await service.getStatisticheValidatori(fd);
        items.value = response.items;
      } catch (error) {
        console.error('Errore nel recupero delle statistiche:', error);
      } finally {
        loading.value = false;
      }
    };
    const getCaricamentiDaValidare = async () => {
      await service.getCaricamentiInState(1)
      .then((res)=>{
        Object.keys(res.items).forEach(el => {
          stats.value[el] = res.items[el]
        })
        console.log(stats.value)
      })
    }

    const onTodayClick = () => {      
      selectedDate.value[1] = selectedDate.value[0];
      onChangeDate();
    };

    const onChangeDate = () => {
      if (selectedDate.value == null || selectedDate.value[1]) {
          getData()
        }
    };

    const getValidationCountClass = (count) => {
      if (count >= 50) return 'validation-high';
      if (count >= 20) return 'validation-medium';
      if (count >= 10) return 'validation-low';
      return 'validation-minimal';
    };

    const exportTable = () => {
      const csvContent = convertToCSV();
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `statistiche_validatori_${moment().format('YYYY-MM-DD')}.csv`;
      a.click();
      window.URL.revokeObjectURL(url);

      toast.add({
        severity: 'success',
        summary: 'Export Completato',
        detail: 'File statistiche esportato con successo',
        life: 3000
      });
    };

    const convertToCSV = () => {
      const headers = ['N. Contratti Validati', 'Utente Validatore', 'Giorno Validazione'];
      const rows = filteredItems.value.map(item => [
        `"${item.quanti || ''}"`,
        `"${item.chi || ''}"`,
        `"${moment(item.giorno).format('DD/MM/YYYY')}"`
      ].join(',')).join('\n');

      return `${headers.join(',')}\n${rows}`;
    };

    onMounted(() => {
      getCaricamentiDaValidare()
      initializeDateRange()
      getData()
    });

    return {
      items,
      filteredItems,
      loading,
      moment,
      selectedDate,
      maxDate,
      totalValidazioni,
      uniqueValidators,
      mediaValidazioniPerGiorno,
      getValidationCountClass,
      exportTable,
      onTodayClick,
      onChangeDate,
      stats
    };
  }
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');

.statistiche-validatori {
  font-family: 'Montserrat', sans-serif;
  padding: 1.5rem;
}

.header-section {
  margin-bottom: 2rem;
}

.page-title {
  font-size: 1.8rem;
  color: #333;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.subtitle {
  color: #666;
  font-size: 1rem;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem;
  color: #666;
  gap: 1rem;
}

.content-section {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
}

/* MODIFICHE AI BOX STATISTICHE */
.stat-card {
  background: #84b3bc;
  color: white;
  padding: 2rem 1.5rem;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 4px 16px rgba(132, 179, 188, 0.3);
  transition: all 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(132, 179, 188, 0.4);
}

.stat-card-success {
  background: #215159;
  box-shadow: 0 4px 16px rgba(33, 81, 89, 0.3);
}

.stat-card-success:hover {
  box-shadow: 0 6px 20px rgba(33, 81, 89, 0.4);
}

.stat-card-warning {
  background: #832700;
  box-shadow: 0 4px 16px rgba(131, 39, 0, 0.3);
}

.stat-card-warning:hover {
  box-shadow: 0 6px 20px rgba(131, 39, 0, 0.4);
}

.stat-number {
  font-size: 2.8rem;
  font-weight: 800;
  margin-bottom: 0.5rem;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.stat-label {
  font-size: 1rem;
  opacity: 0.95;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.tables-section {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.table-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.table-header {
  background: #2c3e50;
  color: white;
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.table-title {
  margin: 0;
  color: white;
  font-size: 1.2rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.table-wrapper {
  padding: 0;
}

.export-button {
  background: transparent !important;
  border: 2px solid white !important;
  color: white !important;
}

.export-button:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: white !important;
  color: white !important;
}

.validation-count-badge {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  font-size: 0.9rem;
  font-weight: 600;
  text-align: center;
  min-width: 30px;
  color: rgb(0, 0, 0);
}

/* .validation-high {
  background: #05b4a5;
}

.validation-medium {
  background: #215159;
}

.validation-low {
  background: #f39c12;
}

.validation-minimal {
  background: #95a5a6;
} */

.user-badge {
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

.date-badge {
  color: #2c3e50;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

:deep(.p-calendar) {
  border-radius: 10px;
  border: 2px solid #bdbdbd;
  transition: all 0.3s ease;
  overflow: hidden;
}

:deep(.p-calendar:focus-within) {
  border-color: #ff8e3d;
  box-shadow: 0 0 0 3px rgba(255, 142, 61, 0.15);
}

:deep(.p-calendar .p-inputtext) {
  border: none;
  padding: 0.8rem 1rem;
  font-weight: 600;
  background: white;
  font-size: 0.95rem;
}

:deep(.p-calendar .p-datepicker) {
  border: 2px solid #84b3bc;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

:deep(.p-calendar .p-datepicker .p-datepicker-header) {
  background: #832700;
  color: white;
  padding: 1.2rem;
  border-bottom: 2px solid #ff8e3d;
}

:deep(.p-calendar .p-datepicker .p-datepicker-header .p-datepicker-title) {
  color: white;
  font-weight: 700;
  font-size: 1.1rem;
}

:deep(.p-calendar .p-datepicker .p-datepicker-header .p-datepicker-prev,
  .p-calendar .p-datepicker .p-datepicker-header .p-datepicker-next) {
  color: white;
  border-radius: 8px;
  width: 2.2rem;
  height: 2.2rem;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.1);
}

:deep(.p-calendar .p-datepicker .p-datepicker-header .p-datepicker-prev:hover,
  .p-calendar .p-datepicker .p-datepicker-header .p-datepicker-next:hover) {
  background: #ff8e3d;
  color: white;
  transform: scale(1.05);
}

:deep(.p-calendar .p-datepicker .p-datepicker-calendar) {
  background: white;
  padding: 1rem;
}

:deep(.p-calendar .p-datepicker .p-datepicker-calendar th) {
  color: #215159;
  font-weight: 700;
  padding: 0.8rem 0.5rem;
}

:deep(.p-calendar .p-datepicker .p-datepicker-calendar td span) {
  border-radius: 8px;
  transition: all 0.3s ease;
  font-weight: 600;
  width: 2.2rem;
  height: 2.2rem;
  line-height: 2.2rem;
}

:deep(.p-calendar .p-datepicker .p-datepicker-calendar td span:hover) {
  background: #84b3bc;
  color: white;
  transform: scale(1.1);
}

:deep(.p-calendar .p-datepicker .p-datepicker-calendar td.p-highlight span) {
  background: #ff8e3d;
  color: white;
  border: 2px solid #832700;
}

:deep(.p-calendar .p-datepicker .p-datepicker-calendar td.p-datepicker-today span) {
  background: #215159;
  color: white;
  font-weight: 800;
}

:deep(.p-calendar .p-datepicker .p-datepicker-buttonbar) {
  background: #f8f9fa;
  border-top: 2px solid #84b3bc;
  padding: 1rem 1.5rem;
}

:deep(.p-calendar .p-datepicker .p-datepicker-buttonbar .p-button) {
  background: #84b3bc;
  border: none;
  color: white;
  border-radius: 8px;
  font-weight: 600;
  padding: 0.6rem 1.2rem;
  transition: all 0.3s ease;
}

:deep(.p-calendar .p-datepicker .p-datepicker-buttonbar .p-button:hover) {
  background: #215159;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(33, 81, 89, 0.3);
}

@media (max-width: 768px) {
  .statistiche-validatori {
    padding: 1rem;
  }

  .page-title {
    font-size: 1.5rem;
  }

  .stats-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .table-header {
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
  }

  .stat-card {
    padding: 1.5rem 1rem;
  }

  .stat-number {
    font-size: 2.2rem;
  }
}

:deep(.p-datatable) {
  background: transparent;
  overflow: hidden;
}

:deep(.p-datatable .p-datatable-thead > tr > th:hover) {
  background-color: #2c3e50 !important;
  color: white;
}

:deep(.p-datatable .p-datatable-thead > tr > th) {
  background: #9fadbd;
  color: white;
  border: none;
  font-weight: 600;
  padding: 1rem 0.75rem;
  font-size: 0.9rem;
}

:deep(.p-datatable .p-datatable-tbody > tr) {
  background: white;
  border: none;
  color: black !important;
}

:deep(.p-datatable .p-datatable-tbody > tr > td) {
  border: none;
  border-bottom: 1px solid #f0f0f0;
  padding: 0.75rem;
  color: #2c3e50;
  font-weight: 500;
}

:deep(.p-datatable .p-datatable-tbody > tr:hover) {
  background: rgba(5, 180, 165, 0.1);
}

:deep(.p-datatable .p-datatable-tbody > tr:nth-child(even)) {
  background: #f8f9fa;
}

:deep(.p-datatable .p-datatable-tbody > tr:nth-child(even):hover) {
  background: rgba(5, 180, 165, 0.15);
}

:deep(.p-paginator) {
  background: #f8f9fa;
  border: none;
  border-top: 1px solid #dee2e6;
  padding: 1rem;
}

:deep(.p-paginator .p-paginator-pages .p-paginator-page.p-highlight) {
  background: #2c3e50;
  border-color: #05b4a5;
  color: white;
}

:deep(.p-paginator .p-paginator-pages .p-paginator-page:hover) {
  background: rgba(5, 180, 165, 0.1);
  border-color: #05b4a5;
}
</style>